import {Component, OnInit, ViewChild} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import Swal from 'sweetalert2';
import {ToastrService} from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Subscription} from "rxjs";
import {SharedDataService} from "../../../../shared/services/shared-data.service";
import {CustomerLicenseService} from "../../services/customer-license.service";
import {CustomerLicense} from "../../interface/customer-license";

@Component({
  selector: 'app-customer-license',
  templateUrl: './customer-license.component.html',
  styleUrls: ['./customer-license.component.scss']
})
export class CustomerLicenseComponent implements OnInit {

  public customerLicenses!: CustomerLicense[];

  public userPermissions = [];
  private permissionsSubscription: Subscription;

  temp = [];
  selected = [];
  public closeResult: string;
  public getDismissReason: string;
  public isButtonVisible = false;

  customerLicense = this.translate.instant('Customer License');
  product = this.translate.instant('product');

  are = this.translate.instant('are you sure?');

  rows = [];
  loadingIndicator = true;
  reorderable = true;
  @ViewChild(DatatableComponent) table: DatatableComponent;
  constructor(public customerLicenseService: CustomerLicenseService,
              private sharedDataService: SharedDataService,
              private toast: ToastrService,
              private translate: TranslateService,
              private router: Router, ) {
    this.getCustomerLicenseList();


    this.permissionsSubscription = this.sharedDataService.permissions.subscribe((data) => {
      this.userPermissions = data;
      console.log(data);
    });

  }

  ngOnInit() {
  }

  getCustomerLicenseList(): any
  {
    this.customerLicenseService.getCollection().subscribe({
      next: (res: any) => {
        console.log(res);
        this.customerLicenses = res['hydra:member']
        // this.CustomerLicensees = res['hydra:member'][0].table;

        console.log(this.customerLicenses);

        // cache our list
        // this.temp = [...res['hydra:member']];
        this.temp = [...res['hydra:member']];

        this.rows = this.customerLicenses;

        this.loadingIndicator = false;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error.message);
        console.log('Error while fetching the records');
        this.loadingIndicator = false;
      }
    });
  }

  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);
    console.log(this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

     this.isButtonVisible = this.selected.length > 0;
  }

  onActivate(event) {
    console.log('Activate Event', event);
  }

  add() {
    this.selected.push(this.rows[1], this.rows[3]);
  }

  update() {
    this.selected = [this.rows[1], this.rows[3]];
  }

  remove() {
    this.selected = [];
  }

  displayCheck(row) {
    return row.name !== 'Ethel Price';
  }

  edit(row: any) {
  }

  delete(row: any) {

  }

  toggleExpandRow(row) {
    console.log('Toggled Expand Row!', row);
    this.table.rowDetail.toggleExpandRow(row);
  }

  onDetailToggle(event) {
    console.log('Detail Toggled', event);
  }

  deleteCustomerLicense(id: number): any{
    Swal.fire({
      title: this.translate.instant('are you sure?'),
      text: this.translate.instant('you won\'t be able to revert this!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('yes, delete it!'),
    }).then((result) => {
      if (result.isConfirmed) {
        this.loadingIndicator = true;
        this.customerLicenseService.delete(id).subscribe({
          next: (res) => {
            this.toast.success(this.translate.instant('customer license') + ' ' + this.translate.instant('deleted') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.getCustomerLicenseList();
          },
          error: (res) => {
            this.loadingIndicator = false;
            this.toast.error(res['hydra:title'], 'Error');
          }
        });
      }
    });
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    this.rows = this.temp.filter(function(d) {
      return d && (d.name.toLowerCase().indexOf(val) !== -1 || !val);
    });
    this.table.offset = 0;
  }

  ngOnDestroy(): void {
    this.permissionsSubscription.unsubscribe();
  }

}
